import PropTypes from 'prop-types';
import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // optional
import ActivityIndicator from 'creatella-react-components/lib/ActivityIndicator';

import './LoginScreen.scss';

NewDeviceScreen.propTypes = {
    resendEmail: PropTypes.func.isRequired,
    isProcessing: PropTypes.bool.isRequired,
    page: PropTypes.object
};

function NewDeviceScreen({ resendEmail, isProcessing, page }) {
    return (<>
        <div className='loginScreen new-device'>
            <form
                className='loginForm'>
                <img src={page.logo} alt='Paper Trader' className='new-device__logo' />
                <h5 className='new-device__title'>
                Authorize New Device
                </h5>
                <p className='new-device__desc'>
                It looks like you’re signing in to Paper Trader from a computer or device we haven’t seen before, or for some time.
                </p>
                <p className='new-device__desc'>
                Please <span className='new-device-bold-text'>click the confirmation link in the email we just sent you</span>. this is a process that protects the security of your account.
                </p>
                <p className='new-device__desc'>
                    <span className='new-device-bold-text'>Important note: you must open this email using the same device you used to sign in to Paper Trader.</span>
                </p>

                <div>
                    { isProcessing ? <div className='new-device__loading'>
                        <ActivityIndicator />
                    </div>
                        : <span className='new-device__not-arrive' onClick={resendEmail}>Email didn’t arrive?</span>
                    }
                </div>

                <Tippy allowHTML={true} placement='top-end' className='pt-tooltip'
                    content={<p>If you need to change your Email , please contact a Company Account Admin. If you need further assistance, contact support.</p>}>
                    <span className='new-device__help'>I no longer have access to my email address</span>
                </Tippy>
            </form>
            <div>
                <p className='new-device-support'>Visit our <span className='new-device-support__span'>Support Center</span>.</p>
            </div>
        </div>
    </>
    );
}

export default NewDeviceScreen;
